const MuiPickersBasePicker = {
  container: {
    padding: '25px',
    background: 'rgba(73,140,207,0.95)'
  }
};

export default MuiPickersBasePicker;
